import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth21: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '129.9 58.8 123.3 42.7 107.9 34.2 91.7 31 65.9 31.3 16.4 34.1 9.2 35.7 6.5 38.5 4.6 43.6 4.4 60.7 6.1 74.6 9.3 91.1 12.7 107.1 14.2 121.2 15.4 130.5 18.1 140.6 21.4 148.6 24 155.8 28.6 167.2 32.2 174.4 37.7 182.3 40.7 187.2 48 191.5 55.6 194 69.1 195.6 74.8 195.7 87.9 193.4 96.5 189.3 103 182.1 108.8 174.3 112.5 167.7 112.6 163.1 118.9 148 122.7 134.3 126 116.1 127.4 101.3 130.8 77.8 130.9 64.7 129.9 58.8',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112.8,165.7l-3.3,6.5-4.8,8.6-3.3,3.8-5.7,4.9-6.1,2.5-9.4,2.7s-7.9.1-8.2.1h-9.1s-7.3-.5-7.3-.5l-6.5-2.4-7.1-4.8-4.8-5-3.5-4.8-3.5-6.7-2.8-5.3-3.7-9.2,1.6,18.2,3.4,6.7,5.6,6.6,6,5.8,7.3,3.9,8.6,2.1,7.8.4h10.1s8.4-.6,8.4-.6l8.7-3,7.2-2.5,6.5-5.2,5.3-6.4,1.3-2.6,1.3-14Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.3,107.2a16.1,16.1 0 1,1 -32.2,0a16.1,16.1 0 1,1 32.2,0',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '129.5 59.3 4 59.3 4 45.5 5.4 41.1 7.7 37.3 11.3 35.3 22.9 33.2 66.5 31.3 93 31.3 102 33 107.2 34.1 123.1 43.2 129.5 59.3',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.2,141l-3.4-13.1-2.3-18.1-2-13.4s54.8,12.4,7.7,44.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.4,97.4l-1.2,13.4-2.4,18.2-3.7,12.5s-47.3-27.6,7.2-44.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.2,33.6l-27,.4-7.9.9-5.5,1.7-3.4,6.1-1.3,9.1.6,8.9,1.7,13.8,3.4,18.5,2.3,12.5,1.3,11,1.5,12.5,4.7,16.3,3.6,6.8,2.3,7.4,7.1,15.1,6.1,9.7s12.3-32.1,10.7-150.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.9,60.3l-6.7-16.9-15.8-8.9-14.2-2.7h-8.2s-8.4,131.3,11.1,156.9l5-3.8,4.4-5.3,3-5.4,3.1-6,.9-1.5,5.8-17.1,3.5-11.9,2.4-7.8,1.4-11.3,1.5-13.2,1.6-13.3,1.4-14.8-.2-11.8v-5.3Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.4,43.1l1.2-4.1,6-3.9,7.9-.9h5.1c0,0,41.1-2.2,41.1-2.2l27.3-.3,12.7,1.9,16.1,9,7,17.2.4,18.8-4.2,33.4-2.1,17.9-2.9,12.1-7.6,19.3-.5,5.4-6,11.1-5.1,6.5-5.2,5.5-7,2.7-7.1,1.8-7.4.8h-3.6c0,0-7-2.3-7-2.3l-4.7.6s-1.5.4-1.8.5-3,0-3,0l-2.6-1.4-4.1-2.3-5.5-3.5-4-3.1-4.1-6.1-10.7-22.5-8.6-24.7-9.3-56.4-2.3-19.8.5-7.7.8-3.6Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'10.9 93.4 25.4 109.5 28.9 83.2 40.3 114.6 48.9 83.2 59.5 116.2 69.3 85.2 79.9 116.2 89.4 84.8 99.6 116.2 107.4 85.6 113.3 110.7 125.1 92.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'61.1 377.6 72.5 365.9 60.4 358.8 71.3 352 61.1 345.9 73 338.6 61.9 332 72.1 325.5 60.9 318.8 71 312.6 59.6 305.8 70 299.4 60.2 293.5 68.8 288.2 58.7 282.3 68 276.6 58.1 270.7 67.8 264.6 58.4 259 67.3 253.5 57.9 247.9 69.1 241 59.4 235.3 69.1 229.2 59.2 223.3 70.1 216.6 59.6 210.3 71.3 203 61.1 196.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'39.7 268.4 45.7 279.2 51.7 268.1 58.7 280.2 65.8 268.1 71.7 280.8 78.3 270.3 83.7 279.2 88.3 269.4 92.6 280.2 96.4 270',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '117.4 85.8 12.7 85.8 9.2 91.1 7.2 94.8 6.2 97.5 5.9 102.9 6.7 106 10.4 110.5 13.7 113.5 15.6 114.9 117.9 114.9 121.5 112.4 124.1 111.3 127.1 108.4 128 105.8 128.5 104.8 128.7 98.6 127.2 93.6 122.2 89.1 117.4 85.8',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M91.2,82.9l-53.5-.5s26.8-12.7,53.5.5Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.9,114.9l3.6-2.4,2.6-1.2,3-2.9.9-2.6.6-1v-6.2c.1,0-1.3-5-1.3-5l-5-4.5-4.9-3.3s-45.2,13.9.5,29.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12.7,85.8l-5.5,9.1-.9,2.7-.3,5.3.8,3.2,3.8,4.4,5.2,4.4s47.8-15.5-2.9-29.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.7,102.5l1.1,4.2,4.3,4.2,4.8,4,6.8,9.1,8.2,9.9,3.8,4.2,4.5,3.8,6.1,3.7,3.7,2,4,1.2,4.9,1h1.7c0,0,7.7.4,7.7.4l6.8-1.5,6.8-3.3,6.7-4.9,5.1-4.7,5-4.7,4.8-4.9,5.1-5.1,5-4,4.8-1.4,4.5-3.1,4.1-2.4,2.3-3.1,1.1-3.2s-49.2-11-123-1.6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.7,104.1v-6.3c0,0-3.4-5.9-3.4-5.9l-4.6-3.8-10.4-8.2-12.7-8.6-11.1-4.4-9.5-2.6-10.9-2.1-5.2-.6h-17.4s-7,1.2-7,1.2l-3.6.9-6.4,4.4-5.3,4.9-4.4,5.6-4.4,6.5-4.2,6.4-1.9,4.2-.6,1.8v5c0,0,62.7-9.3,122.9,1.6Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.2,70.2l10-6.9,12.6-2.2,13.9.6,12.6,1.3,13.2,2.8,9.7,3.9,9.3,5.9,9.5,7.4,9.5,7.2,4.6,5.6.7,5.8-.4,3-3,4.6-2,2.2-3.7,1.9-3.7,2.8-2.4.6-1.7.4-11,8.9-9.7,10.4-8,6.7-6.3,4.1-8.4,2.6-3.3.7s-6.3-.6-7.1-.6-4.6-.4-4.6-.4l-11.3-4.5-5.9-5.4-9.1-9.8-11.1-14.3-8-6.3-3-5.4-.6-6.5,5.6-8.9,13-18.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'5.9 96.3 21.3 110.5 25 87.3 36.9 115 46.1 87.3 57.2 116.4 67.6 89 78.7 116.4 88.8 88.7 99.5 116.4 107.8 89.4 114 111.5 126.4 95.6',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M95.7,388.4h-52.5s24.4-113.1,52.5,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '132.1 460.1 3.7 460.1 3.6 470 4.8 474 6 476.9 8.2 479.9 10.9 481.4 14 482.9 61.1 486.6 83.5 489.5 98.3 489.5 106.3 488.5 122.4 479.9 132.1 463.7 132.1 460.1',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.4,442.2s68.7-13.4,5.1-45.3',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.6,400.2s-64.6,26.9,4.1,45.4',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M48.8,485.6s15.1-112-27.4-135.1l-4,18.3-3.8,15.8-3,15.3-2.5,15.8-1,13.1-2.3,14.3-.8,8.8s0,17.8.3,18.8,1,4.5,1,4.5l2.3,3.8,4.5,2.8,6.3,1.8,30.4,2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M83.9,490.1s-4.3-121.5,31.1-131.8l5.5,14.1,4,12.6,2.8,10,2,14.8,1,12.8,1.8,13.3.3,13.1.3,11.5-.5,4.3-8.3,14.3-16.6,9.5-14.1,1.8-9.3-.3Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '114.8 356.7 108.1 345.6 102.3 340.3 99.6 339.5 89.3 332.4 84.5 329.6 71.6 325.5 61.1 324.9 53 324.6 46 325.8 39.7 327 34.8 330.5 31.1 333.8 28.5 337.2 25.9 341.5 23.5 345.9 21.6 350.6 20.5 353.2 19.3 359.3 16.2 372.4 12.4 389.3 9.6 405.5 6.7 426.4 4.4 445.4 3.8 451.5 4 471 5.1 475.1 7.5 478.7 10.8 481.4 12.6 482.2 21.7 484 58 486.7 82.1 489.1 93.1 489.7 105.9 488.4 122.7 479.7 131.4 465.7 133 444.3 129.7 413.1 128 396.2 123.6 378.2 119.5 367.6 114.8 356.7',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.7,356.6l-6.1-11.1-7.3-5.9-10-6.8-7.2-3.6-6.9-2.5-8.1-2.2-5.7-.2-7.6-.5s-5.8.3-6.2.3-9.2,2.1-9.2,2.1l-3.1,1.9-3.9,3.7-2.6,2.7-2.8,4.3-1.4,2.2-2.1,4-1.8,4.1-2.1,6,.4-7.2.5-8.5.8-4.6,3.8-6,3.2-3,5.5-3,3.9-1.3,5.4-1.4,6.6-1.1h5.5s4.5,0,4.5,0h4c0,0,5,.5,5,.5l7.7,1.2,5.9,2,6.1,1.9,6,2.9,5,2.9,5,3.9,5.3,4.7,2.6,3.1,1.2,2.2.2,12Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '22.2 349.2 27.5 340.2 32.7 333 39.9 326.7 50.3 324.2 62.9 324.1 70.1 325.1 76 325.8 82.4 328.1 90.2 331.8 97.3 337.2 101.7 340 106.4 342.2 109.1 345.7 111.4 350.7 115 356.6 120.5 369 124 378.4 127.1 391.7 127.9 399.9 129.8 417 132.9 447.3 132.3 462.8 123.4 479.9 107.5 487.6 90.4 490.4 53 485.6 15.1 482.7 9.8 480.2 7 477.5 4.5 470.6 3.9 449.5 8.5 410 22.2 349.2',
			},
			[ToothSurface.BuccalRestoration]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M115.1,357.7l-6.4-11.4-4.7-4.7-8.3-5.9-6.2-4-7.8-4-7.2-2s-5.8-1-6-1-5.4-.5-5.4-.5h-7c0,0-4.3,0-4.3,0l-7.3,1.3-5.2,1.5-2.1,1.5-4.6,3.9-3.8,4.2-2.7,4.4-2.6,4.9-1.8,5-1.8,5.6c24.3,5.2,28.4,97.3,28.4,97.3l33.3.2s4.7-79.9,33.6-96.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'128.6 423 116.4 404.4 110.3 430.4 102.2 398.7 91.6 431.2 81.8 398.7 70.8 430.8 60.7 398.7 49.7 432.9 40.8 400.4 29 432.9 25.4 405.6 10.4 422.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'61.1 322.6 71.6 315.8 59.6 307.6 70.4 300.5 59.2 293 69.4 286.4 59.4 279.6 69.4 273.2 57.8 265.5 67.5 259.2 58.3 253.1 68 246.8 58 240 68.2 233.4 58.7 227 69 220.4 60.2 214.5 70.2 207.9 59.6 200.7 71.3 193.1 60.9 186.1 72.5 178.6 62 171.5 73.3 164.1 61.1 155.9 71.6 149 60.4 141.4 72.8 133.4 61.2 120.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'97.9 246.2 93.8 234.8 88.9 246.8 83.8 235.9 77.7 245.9 70.4 234.1 63.8 248.2 55.8 234.8 48 248.2 41.4 235.9 34.7 247.9',
			],
		},
	},
};
